<template>
  <div id="news" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="our_news"></div>
    <div class="container" style="max-width: 1024px !important;">
      <el-row :gutter="50">
      </el-row>
      <div class="block" id="block">
        <div class="news">
          <el-row :gutter="50">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>新闻中心</el-breadcrumb-item>
                <el-breadcrumb-item :to="{path:pathto}">{{path}}</el-breadcrumb-item>
                <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
              </el-breadcrumb>
              <template>
                <h2 style="width: 100%;text-align: center;margin-top: 30px;" class="title-color">{{title}}</h2>
                <p class="times">发布时间：{{time}}</p>
                <div id="content" class="content-news" style="margin: 30px 0 70px 0px;" v-html="content">{{content}}
                </div>
                <el-divider></el-divider>
                <!-- <div class="pre-news" style="margin-top: 20px;">
                  <el-link @click="toLoad(preId,weigh)">上一篇：{{pre}}</el-link>
                </div>
                <div class="next-news">
                  <el-link @click="toLoad(nextId,weigh)">下一篇：{{next}}</el-link>
                </div> -->
              </template>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'news',
    components: {
      navheader,
      fixheader,
      filing
    },
    data() {
      return {
        id: 0,
        number: 0,
        weigh:0,
        type: 0,
        title: "",
        content: "",
        path: "",
        time: "",
        pathto: "",
        next: "",
        pre: "",
        nextId: 0,
        preId: 0,
        weigh:0
      }
    },
    beforeCreate() {
      let _that = this;
      this.axios.get(this.$http + "api/index/getContentnews", {
          params: {
            id: _that.$route.query.number,
          }
        })
        .then((res) => {
          console.log(res);
          this.content = res.data.data[0].content;
          this.title = res.data.data[0].title;
          this.time = this.timestampToDate(res.data.data[0].createtime);
        })
        .catch((err) => {})

    },
    mounted: function() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
      this.weigh = this.$route.query.weigh;

      this.preId = Number(this.weigh) + 1;
      this.nextId = Number(this.weigh) - 1;
      this.type = this.$route.query.type;
      if (this.type == 1) {
        this.path = "最新动态",
          this.pathto = "/news"
      }
      if (this.type == 2) {
        this.path = "企校合作",
          this.pathto = "/cooper"
      }
      this.loadContent();
      this.loadtitle();
      var h = window.screen.availHeight - 525;
      document.getElementById("block").setAttribute("style", "min-height:" + h + "px");
    },
    methods: {
      loadContent() {
      },
      toLoad: function(mallCode) {
        this.$router.push({
          path: '/content',
          query: {
            number: mallCode
          }
        })
        location.reload();
      },
      loadtitle(){
        this.axios.get(this.$http + "api/index/getOthernews", {
            params: {
              weigh: parseInt(this.$route.query.weigh) - 1,
              newsid: this.$route.query.type
            }
          })
          .then((res) => {
            this.pre = res.data.data[0].title;
            this.preId = res.data.data[0].id;
            this.weigh = res.data.data[0].weigh;
          })
          .catch((err) => {})

          this.axios.get(this.$http + "api/index/getOthernews", {
              params: {
                weigh: parseInt(this.$route.query.weigh) + 1,
                newsid: this.$route.query.type
              }
            })
            .then((res) => {
              this.next = res.data.data[0].title;
              this.nextId = res.data.data[0].id;
              this.weigh = res.data.data[0].weigh;
            })
            .catch((err) => {})
      },
      timestampToDate(timestamp) {
        if (timestamp.toString().length !== 10) {
          throw new Error('The timestamp should be a 10-digit integer.');
        }
        const date = new Date(timestamp * 1000); // 10位时间戳是秒级，需要乘以1000转换为毫秒
        return date.toISOString().slice(0, 19).replace('T', ' '); // 格式化为YYYY-MM-DD HH:MM:SS
      }
    }
  }
</script>

<style>
  .title-color,
  .content-news {
    color: #606266;
  }

  #content.content-news p {
    line-height: 28px !important;
  }

  #content img {
    max-width: 100% !important;
  }

  #news .times {
    color: rgba(0, 0, 0, 0.7);
    text-align: center;
    line-height: 26px;
    font-size: 15px;
  }

  #news .pre-news,
  #news .next-news {
    color: rgba(0, 0, 0, 0.7);
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/content/Our_content.vue